// extracted by mini-css-extract-plugin
export default {"actions":"termModal_actions__xcJtW","validFrom":"termModal_validFrom__BfPRL","reviewReason":"termModal_reviewReason__w0jbe"};